<template>
  <div class="backwihte width100 margin-auto pad-bot30">
    <div class="stewardbox">
      <div class="textalign-left pad-bot10 f16">商标申请</div>
      <div class="patentapp">
        <div class="passrateBox">
          <div class="itemnameBox">
            <el-checkbox-group
              v-model="checkedCities"
              :max="5"
              v-for="(item, index) in cities"
              :key="index"
              @change="PersonnelChange"
              class="itemname"
            >
              <el-checkbox :label="index">{{ item.tname }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="inputbox">
          <div class="width49 margin-top10">
            <p>商标名称</p>
            <el-input
              placeholder="请输入商标名称"
              v-model="patent"
              clearable
              class="input"
            >
            </el-input>
          </div>

          <div class="width49 margin-top10">
            <p>商标图片</p>
            <el-input
              placeholder="请上传商标图片"
              v-model="filename"
              class="input"
              maxlength="0"
            >
              <template slot="append">
                <el-upload
                  class="avatar-uploader"
                  :action="Apisrc"
                  name="images"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :on-error="handleerror"
                  :data="user"
                  :headers="head"
                >
                  上传
                </el-upload></template
              >
            </el-input>
          </div>
          <div class="width49 margin-top10">
            <p>申请时间</p>
            <el-date-picker
              class="input datepic"
              v-model="apply_date"
              type="date"
              placeholder="计划申请时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>

          <div class="width49 margin-top10">
            <p>联系人</p>
            <el-input
              placeholder="请输入联系人"
              v-model="contact"
              clearable
              class="input"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="margin-top20 textalign-right">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button type="primary" @click="addpant()">立即申请</el-button>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { enttrademarkapplysave } from "@/api/newhead/newhead.api";
import { trademarktoolsclass } from "@/api/patent/patent.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      checkedCities: [],
      cities: [],
      input: "",
      input2: "",
      Apisrc: "",
      user: {
        // images: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      patent_type: "",
      patent: "",
      files: "",
      apply_date: "",
      contact: "",
      filename: "",
      PersonnelChangeid: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    // 获取选取国际分类测试id
    PersonnelChange(val) {
      this.PersonnelChangeid = val;
    },

    // 上传
    handleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.files = response.data.url;
        this.filename = file[0].name;
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    // 商标申请
    addpant() {
      enttrademarkapplysave({
        apply_date: this.apply_date,
        contact: this.contact,
        class_id: this.PersonnelChangeid,
        trademark: this.patent,
        image: this.files,
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("onlineactiveName", "first");
          BUS.$emit("Applyfor", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialognull() {
      BUS.$emit("Applyfor", "yesno");
    },
  },
  components: {},
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";

    // 获取商标国际分类
    trademarktoolsclass({}).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.cities = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  updated() {},
};
</script>

<style scoped>
.stewardbox {
  width: 95%;
  margin: auto;
  padding: 20px 0 0 0;
}
.stewardtitle {
  font-size: 14px;
  color: #0039bf;
  text-align: center;
}
.patentapp {
  width: 100%;
  min-height: 100px;
  background: #f6f7fb;
  margin: 10px 0 0 0;
  border-radius: 3px;
  padding: 0 0 20px 0;
}
.itemnameBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px 0 10px 10px;
}
.itembotBox {
  width: 90%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 0 10px 10px;
}
.itemname {
  width: 20%;
}
.itemname >>> .el-checkbox__label {
  font-size: 12px;
}
.radiogroup {
  padding: 20px 0 10px 10px;
}
.inputbox {
  width: 98%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.input {
  margin: 5px 0 0 0;
}
.datepic {
  width: 100%;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>>
